import { render, staticRenderFns } from "./User_booking.vue?vue&type=template&id=544da5f8"
import script from "./User_booking.vue?vue&type=script&lang=js"
export * from "./User_booking.vue?vue&type=script&lang=js"
import style0 from "./User_booking.vue?vue&type=style&index=0&id=544da5f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports